import 'regenerator-runtime/runtime';

(function (global) {
    // jquery should be before angular
    global.jQuery = global.$ = require('jquery');
    // 10-year data range is enough here: these legacy pages only format current dates
    global.moment = require('moment-timezone/builds/moment-timezone-with-data-10-year-range');
    require('angular');
    global.angular = angular;
})(typeof window !== 'undefined' ? window : {});
